import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../../../store/root-reducer';
import { updateHasErrorsInContactDetailsForm } from '../../../../../../../../dialer-slice';
import FormWithoutBundle, { FormValues } from './form-without-bundle';

export type { FormValues };

export interface FormWithoutBundleContainerProps {
  onFormValuesChange?: (values: FormValues) => void;
  initialValues?: FormValues;
}

const FormWithoutBundleContainer = memo(({ onFormValuesChange, initialValues }: FormWithoutBundleContainerProps) => {
  const dispatch = useDispatch();
  const hasErrorsInContactDetailsForm = useSelector(
    (state: RootState) => state.dialer.hasErrorsInContactDetailsForm,
  );

  const handleUpdateHasErrorsInContactDetailsForm = useCallback(
    (hasErrors: boolean) => {
      dispatch(updateHasErrorsInContactDetailsForm(hasErrors));
    },
    [dispatch],
  );

  return (
    <FormWithoutBundle
      hasErrorsInContactDetailsForm={hasErrorsInContactDetailsForm}
      updateHasErrorsInContactDetailsForm={handleUpdateHasErrorsInContactDetailsForm}
      onFormValuesChange={onFormValuesChange}
      initialValues={initialValues}
    />
  );
});

FormWithoutBundleContainer.displayName = 'FormWithoutBundleContainer';

export default FormWithoutBundleContainer;

